import { useSelector } from 'react-redux'
import { selectUserType } from '@/features/domain/user'
import { useTexts } from './useTexts'
import { form } from '../../formState'
import { preview } from '@/components/form/preview'

export function Username() {
  const userType = useSelector(selectUserType)
  const texts = useTexts()

  const canEditUsername = ['admin', 'planner', 'gpsonly'].includes(userType)
  const {
    field: { value },
  } = form.useFormField('username')

  return canEditUsername ? (
    <form.TextField
      name="username"
      label={texts.username}
      testId="username"
      disabled={!canEditUsername}
      validateOn="blur change"
    />
  ) : (
    <preview.Field label={texts.username}>
      <preview.Value>{value}</preview.Value>
    </preview.Field>
  )
}
